export const C8_TOGGLE_PRIVACY_SETTINGS_VALUES = Object.freeze({
  TEXT_ENABLED: '1,X,X,1,X,1,1',
  TEXT_DISABLED: '0,X,X,X,X,X,0',
  EMAIL_ENABLED: '1,X,X,X,X,X,X',
  EMAIL_DISABLED: '0,X,X,X,X,X,X'
});



// WEBPACK FOOTER //
// ./src/constants/privacySettings.js